import { Pipe, PipeTransform } from '@angular/core';
import { Form, Pair} from '../services/generated/models';
import { FormService } from '../services/form.service';

@Pipe({
    name: 'getPairText',
    pure: false
})
export class GetPairText implements PipeTransform {

    constructor(private formService: FormService) {}

    transform(pair: Pair, value: true): any {
        const that = this;
        let result = (value) ? pair.ValueForTrue : pair.ValueForFalse;
        if (that.formService.currentForm != null) {
            const t = that.formService.currentForm.Texts.find(x => x.PairId === pair.Id );
            if (t) {
                result =  (value) ? t.ValueForTrue : t.ValueForFalse;
            }
        }
        return result;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/pipes/getPairText.ts